/**
 * Labeled percent progress bar.
 */
import React from "react";
import PropTypes from "prop-types";

import { VText } from "form";

/**
 * Displays a label, percent, and filled track. Uses a muted color when complete.
 *
 * @param {{ label: string, value: number, success?: boolean }} props
 */
const BProgressBar = (props) => {
  const { label, value, success = false, ...rest } = props;

  return (
    <div {...rest}>
      <div className="flex justify-between mb-1">
        <VText className="text-limit-1" color="secondary" div>
          {label}
        </VText>
        <VText>{value}%</VText>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-1.5 dark:bg-gray-700">
        <div className={`${success ? "bg-gray-500" : "bg-blue-600"} h-1.5 rounded-full`} style={{ width: `${value}%` }} />
      </div>
    </div>
  );
};

BProgressBar.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  success: PropTypes.bool.isRequired,
};

export default BProgressBar;
